import * as React from "react";
import { isTrackerOn } from "./activeTrackers";
import { getAdChannels } from "./channels";

/**
 * Every tracker's <head> snippet, as switched on in the app's src/trackers.ts.
 * Spread into gatsby-ssr's onRenderBody. (GTM and klaviyo.js themselves are
 * injected by their Gatsby plugins, see getTrackerPlugins.)
 */
export function getTrackerHeadComponents(): React.ReactNode[] {
  const components: React.ReactNode[] = [];
  if (isTrackerOn("klaviyo")) {
    components.push(klaviyoStub);
  }
  components.push(...getAdChannels().flatMap((c) => c.headComponents()));
  return components;
}

// Klaviyo onsite stub. gatsby-plugin-klaviyo only injects the async klaviyo.js
// script, not this stub, so without it `window.klaviyo` doesn't exist until
// that script downloads and early calls are lost. The stub makes
// `window.klaviyo` a Proxy immediately, queueing calls onto `window._klOnsite`
// which the real library drains once it loads.
const klaviyoStub = (
  <script
    key="klaviyo-stub"
    dangerouslySetInnerHTML={{
      __html: `!function(){if(!window.klaviyo){window._klOnsite=window._klOnsite||[];try{window.klaviyo=new Proxy({},{get:function(n,i){return"push"===i?function(){var n;(n=window._klOnsite).push.apply(n,arguments)}:function(){for(var n=arguments.length,o=new Array(n),w=0;w<n;w++)o[w]=arguments[w];var t="function"==typeof o[o.length-1]?o.pop():void 0,e=new Promise((function(n){window._klOnsite.push([i].concat(o,[function(i){t&&t(i),n(i)}]))}));return e}}})}catch(n){window.klaviyo=window.klaviyo||[],window.klaviyo.push=function(){var n;(n=window._klOnsite).push.apply(n,arguments)}}}}();`,
    }}
  />
);
